import React, { useState } from "react";
import outline from "../../assets/icons/faqs_img-01-01-01.svg";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "./HomeSwiper.css";
import { ChevronDown } from "lucide-react";

const HomeFaqs = () => {
  const faqs = [
    {
      question: "How can I book a consultation?",
      answer:
        "You can book a consultation through the contact form or by calling the clinic directly.",
    },
    {
      question: "What types of cancer do you specialize in?",
      answer:
        "We provide specialized care for breast cancer, lung cancer, oral cancer, gastrointestinal cancers, and more.",
    },

    {
      question: "Do you accept insurance coverage?",
      answer:
        "Yes, major insurance providers are accepted. Please contact the clinic for detailed information.",
    },
    {
      question: "How should I prepare for my first visit?",
      answer:
        "Please bring your previous medical records, scan reports, prescriptions, and any relevant test results.",
    },

    {
      question: "Do you provide second opinions?",
      answer:
        "Yes, second opinion consultations are available for patients seeking expert guidance on diagnosis and treatment plans.",
    },
    {
      question: "Do you offer personalized treatment plans?",
      answer:
        "Yes, every treatment plan is carefully tailored based on the patient’s diagnosis and medical condition.",
    },
    {
      question: "What treatment options are available?",
      answer:
        "Treatment options may include chemotherapy, immunotherapy, targeted therapy, radiation therapy, and surgery.",
    },

    {
      question: "What support is provided during treatment?",
      answer:
        "We provide continuous medical guidance, counseling support, and patient care coordination throughout treatment.",
    },
    {
      question: "Are online consultations available?",
      answer:
        "Yes, online consultations are available for follow-ups and selected patient evaluations.",
    },
    {
      question: "How long does cancer treatment usually take?",
      answer:
        "Treatment duration depends on the type and stage of cancer, as well as the chosen treatment approach.",
    },
  ];

  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className=" xl:py-28 lg:py-20 md:py-14 py-10 relative ">
      <div className="md:top-4 bottom-0 left-0  absolute w-1/3">
        <img
          src={outline}
          alt="outline"
          className="pointer-events-none w-full"
        />
      </div>
      <div data-aos="fade-up" className=" mx-auto xl:max-w-[1280px] w-11/12 flex justify-center items-center flex-col z-10">
        <span className="text-xl font-medium text-[#1d9e75] uppercase border-b border-[#B87333] px-2 py-1.5 ">
          Faq's
        </span>
        <h2 className="lg:text-4xl md:text-3xl text-xl text-center font-bold mt-2 text-matcha leading-tight">
          Frequently asked questions
        </h2>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 items-start xl:mt-28 lg:mt-20 md:mt-16 mt-12">
          {/* Left Column */}
          <div className="flex flex-col gap-6">
            {faqs
              .filter((_, index) => index % 2 === 0)
              .map((faq, index) => {
                const realIndex = index * 2;
                const isOpen = openIndex === realIndex;
                return (
                   <div
                    key={faq.question}
                    className="rounded-lg  bg-matcha backdrop-blur-md overflow-hidden transition-all duration-200 hover:shadow-xl"
                  >
                    <button
                      onClick={() => toggleFAQ(realIndex)}
                      className=" w-full flex items-center justify-between text-left p-3 md:p-4 "
                    >
                      <h3 className="md:text-lg text-base font-semibold text-white pr-4">
                        {faq.question}
                      </h3>

                      <ChevronDown
                        className={`min-w-5 min-h-5 text-[#1d9e75] transition-transform duration-500 ${isOpen ? "rotate-180" : ""}`}
                      />
                    </button>

                    <div
                      className={`  grid transition-all duration-300 ease-in-out ${
                        isOpen
                          ? "grid-rows-[1fr] opacity-100"
                          : "grid-rows-[0fr] opacity-0"
                      } `}
                    >
                      <div className="overflow-hidden">
                        <p className="md:px-6 md:pb-6 px-3 pb-3 text-white leading-relaxed">
                          {faq.answer}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
          {/* Right Column */}
          <div className="flex flex-col gap-6">
            {faqs
              .filter((_, index) => index % 2 !== 0)
              .map((faq, index) => {
                const realIndex = index * 2 + 1;
                const isOpen = openIndex === realIndex;
                return (
                  <div
                    key={faq.question}
                    className="rounded-lg  bg-matcha backdrop-blur-md overflow-hidden transition-all duration-200 hover:shadow-xl"
                  >
                    <button
                      onClick={() => toggleFAQ(realIndex)}
                      className=" w-full flex items-center justify-between text-left p-3 md:p-4 "
                    >
                      <h3 className="md:text-lg text-base font-semibold text-white pr-4">
                        {faq.question}
                      </h3>

                      <ChevronDown
                        className={`min-w-5 min-h-5 text-[#1d9e75] transition-transform duration-500 ${isOpen ? "rotate-180" : ""}`}
                      />
                    </button>

                    <div
                      className={`  grid transition-all duration-300 ease-in-out ${
                        isOpen
                          ? "grid-rows-[1fr] opacity-100"
                          : "grid-rows-[0fr] opacity-0"
                      } `}
                    >
                      <div className="overflow-hidden">
                        <p className="md:px-6 md:pb-6 px-3 pb-3 text-white leading-relaxed">
                          {faq.answer}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeFaqs;
